import { ToastContainer } from "react-toastify"

import { RoutesContainer } from "./RoutesContainer"

const App: React.FC = () => (
  <>
    <div className="min-h-screen w-full">
      <RoutesContainer />
    </div>
    <ToastContainer autoClose={10000} theme={"light"} position={"bottom-left"} />
  </>
)

export { App }
